import { Routes, Route } from "react-router";
import { HomePage } from "../components/home/home";
import { AboutPage } from "../components/about/about";
import { Skills } from "../components/skills/skills";
import { Projects } from "../components/projects/projects";
import { Contact } from "../components/contact/contact";
import { Education } from '../components/education/education';
import { NotFound } from "../components/NotFound/NotFound";
import { Navbar } from "../components/navbar/navbar";
import { Review } from "../components/Reviews/reviews";

export const AllRoutes = () => {

    return(
         <>
             <Routes>
                <Route exact path="/navbar" element={<Navbar/>}/>
                <Route exact path="/home" element={<HomePage />} />
                <Route exact path="/about" element={<AboutPage />} />
                <Route exact path="/education" element={<Education />} />
                <Route exact path="/review" element={<Review/>} />
                <Route exact path="/skills" element={<Skills />} />
                <Route exact path="/projects" element={<Projects />} />
                <Route exact path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound/>}/>
            </Routes> 
        </>
    )
}